import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-266">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-267" />
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" data-id="element-268">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100" data-id="element-269">
          <h2 className="font-serif text-xl font-bold text-stone-900" data-id="element-270">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-stone-100 transition-colors text-stone-500 hover:text-stone-900" aria-label="Cerrar" data-id="element-271">
            <X className="w-5 h-5" data-id="element-272" />
          </button>
        </div>
        {/* Body */}
        <div className="px-6 py-6 overflow-y-auto text-stone-700 leading-relaxed text-sm space-y-4" data-id="element-273">
          {children}
        </div>
      </div>
    </div>;
}